import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Heart, Baby, Eye, Gift, Flower2, HandHeart } from 'lucide-react';

const Home = () => {
  const gammes = [
    {
      id: 'revitalisation',
      title: 'Gamme Revitalisation',
      description: 'Massages aux huiles chaudes traditionnelles pour régénérer votre corps',
      icon: Sparkles,
      color: '#16697A',
      link: '/revitalisation'
    },
    {
      id: 'pieds-mains',
      title: 'Beauté des Pieds & Mains',
      description: 'Pédicure et manucure naturelles pour sublimer vos extrémités',
      icon: HandHeart,
      color: '#d4a017',
      link: '/pieds-mains'
    },
    {
      id: 'mere-fille',
      title: 'Moment Mère & Fille',
      description: 'Un instant de complicité et de détente à partager',
      icon: Heart,
      color: '#b8860b',
      link: '/mere-fille'
    },
    {
      id: 'femme-enceinte',
      title: 'Femme Enceinte & Jeune Maman',
      description: 'Soins adaptés pour accompagner cette période unique',
      icon: Baby,
      color: '#16697A',
      link: '/femme-enceinte'
    },
    {
      id: 'detente',
      title: 'Gamme Détente',
      description: 'Massages signature pour un bien-être profond',
      icon: Flower2,
      color: '#d4a017',
      link: '/detente'
    },
    {
      id: 'beaute-regard',
      title: 'Beauté du Regard',
      description: 'Rehaussement de cils et restructuration des sourcils',
      icon: Eye,
      color: '#b8860b',
      link: '/beaute-regard'
    },
    {
      id: 'anniversaire',
      title: 'Anniversaire MEYA PARTY',
      description: 'Formules spa pour un anniversaire inoubliable',
      icon: Gift,
      color: '#16697A',
      link: '/anniversaire'
    }
  ];

  return (
    <div className="page-home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-pattern" />
        <div className="hero-content">
          <div className="hero-logo">
            <div className="hero-logo-text">Meya</div>
            <div className="hero-logo-subtitle">Beauté & Tradition</div>
          </div>
          <h1 className="hero-title">L'Art du Bien-Être Oriental</h1>
          <p className="hero-description">
            Découvrez nos soins traditionnels inspirés des rituels ancestraux,
            <br />
            pour une expérience de détente authentique et profonde
          </p>
          <div className="hero-buttons">
            <Link to="/reservation" className="btn-primary">
              Réserver un soin
            </Link>
            <Link to="/contact" className="btn-secondary">
              Nous contacter
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container-main">
          <div className="about-content">
            <h2 className="section-title">Bienvenue chez Meya</h2>
            <div className="decorative-line" />
            <p className="about-text">
              Meya Beauté & Tradition est un salon de massage qui célèbre l'authenticité 
              des rituels orientaux. Nous vous proposons une gamme complète de soins 
              utilisant des huiles naturelles précieuses et des techniques ancestrales 
              pour votre bien-être absolu.
            </p>
            <div className="about-values">
              <div className="value-item">
                <div className="value-icon">🌿</div>
                <h3>Produits Naturels</h3>
                <p>Huiles et soins 100% naturels</p>
              </div>
              <div className="value-item">
                <div className="value-icon">🤲</div>
                <h3>Soins Traditionnels</h3>
                <p>Techniques ancestrales respectées</p>
              </div>
              <div className="value-item">
                <div className="value-icon">💆</div>
                <h3>Bien-Être Garanti</h3>
                <p>Moment de détente profonde</p>
              </div>
              <div className="value-item">
                <div className="value-icon">✨</div>
                <h3>Cadre Authentique</h3>
                <p>Ambiance chaleureuse et apaisante</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gammes Section */}
      <section className="gammes-section">
        <div className="container-main">
          <h2 className="section-title">Nos Gammes de Soins</h2>
          <div className="decorative-line" />
          <p className="section-subtitle">
            Découvrez notre sélection de soins traditionnels adaptés à vos besoins
          </p>

          <div className="gammes-grid">
            {gammes.map((gamme, index) => {
              const IconComponent = gamme.icon;
              return (
                <Link
                  key={gamme.id}
                  to={gamme.link}
                  className="gamme-card"
                  style={{ '--card-color': gamme.color }}
                >
                  <div className="gamme-icon" style={{ backgroundColor: gamme.color }}>
                    <IconComponent size={32} strokeWidth={1.5} />
                  </div>
                  <h3 className="gamme-title">{gamme.title}</h3>
                  <p className="gamme-description">{gamme.description}</p>
                  <span className="gamme-link-text">Découvrir →</span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-pattern" />
        <div className="cta-content">
          <h2 className="cta-title">Prête à vivre une expérience unique ?</h2>
          <p className="cta-text">
            Réservez votre moment de détente dès maintenant et laissez-vous transporter 
            par nos rituels de beauté traditionnels
          </p>
          <Link to="/reservation" className="btn-cta">
            Réserver maintenant
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
